(function () {
	document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
		anchor.addEventListener("click", function (e) {
			const hrefAttr = this.getAttribute("href");

			if (hrefAttr.length > 1) {
				const elementForScroll = document.querySelector(hrefAttr);

				if (elementForScroll != null) {
					e.preventDefault();

					elementForScroll.scrollIntoView({
						behavior: "smooth"
					});
				}
			}
		});
	});
})();
